import React from 'react';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';

const createReactClass = require('create-react-class');

const MemberSearchResultItem = createReactClass({
  handleClick() {
    _gaq.push(['_trackEvent', 'Site Search', this.props.term, this.props.data.slug, this.props.index + 1]);
  },
  formatValue(hit, attr) {
    if (hit[attr] instanceof Array) return hit[attr][0];
    return hit[attr];
  },
  handleHover() {
    this.props.hoverHandle(this.props.index);
  },
  render() {
    let formattedName = this.formatValue(this.props.data, 'name');
    if (formattedName.length > 40) {
      formattedName = `${formattedName.substring(0, 40)}...`;
    }
    const formattedUrl = LanguageSupportUtil.wrapUrlSafe(`/members/${this.props.data.slug}`, this.props.languageRegionCode);
    let classes = 'algolia-hit';
    const apiKey = '3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i';
    const objId = this.props.data.objectID;
    const userId = objId;
    // Algolia results don't contain profile photo image data, so must use AllTrails API redirect
    let imageUrl = `/api/alltrails/profile_photos/${userId}`;
    imageUrl += `/image?size=icon&key=${apiKey}`;
    let citystate = '';
    if (this.props.data.city_name) {
      citystate = this.props.data.city_name;
      if (this.props.data.state_name) {
        citystate += `, ${this.props.data.state_name}`;
      } else if (this.props.data.country_name) {
        citystate += `, ${this.props.data.country_name}`;
      }
    }

    if (this.props.selected) classes += ' hit-selected';
    return (
      <div>
        <a href={formattedUrl} onClick={this.handleClick}>
          <div className={classes} onMouseOver={this.handleHover}>
            <img src={imageUrl} className="search-thumb" />
            <span className="search-text" data-test-id="search-text">
              <span>{formattedName}</span>
            </span>
            <br />
            <span className="member-search-info">{citystate}</span>
          </div>
        </a>
      </div>
    );
  }
});

export { MemberSearchResultItem };
